import React, { FC } from 'react';
import Tooltip from 'react-tooltip';
import styles from './filter_item.module.scss';
import { MaterialIcon } from '../../../../../components/material-icon/MaterialIcon';
import { Chip } from '../../../../../components/chips/Chip';

export type FilterType = {
  label?: string;
  labelFull?: string;
  title?: string;
  subTitle?: string;
  handleRemove?: () => void;
};

type Props = {
  filter: FilterType;
};

export const FilterItem: FC<Props> = ({
  filter: { label, labelFull, title, subTitle, handleRemove = undefined },
}) => {
  return (
    <Chip
      color="secondary"
      className={styles.container}
      data-for={labelFull}
      data-tip
    >
      {label}
      {label && title && subTitle && ` · `}
      {title && subTitle && `${title} · ${subTitle}`}
      {handleRemove && (
        <button className={styles.button} onClick={handleRemove} type="button">
          <MaterialIcon name="clear" className={styles.removeIcon} />
        </button>
      )}
      {labelFull && (
        <Tooltip effect="solid" id={labelFull}>
          {labelFull}
        </Tooltip>
      )}
    </Chip>
  );
};
